export function getQueryParams() {
  return location.search
    .slice(1)
    .split("&")
    .map((str) => str.split("="))
    .reduce((acc: { [key: string]: string }, [key, value]) => {
      if (key) {
        acc[key] = decodeURIComponent(value);
      }
      return acc;
    }, {});
}

export function removeQueryParams() {
  window.history.replaceState(
    {},
    document.title,
    location.origin + location.pathname
  );
}

/* 
function querifyArray(ref: any) {
  const [arrayName, array] = Object.entries(ref)?.[0] || [];
  if (!arrayName || !array) {
    throw new Error(`invalid arg: ${ref}`);
  }
  if (!Array.isArray(array)) {
    throw new Error(`${arrayName} must be an array`);
  }
  if (array.length == 0) return "";
  if (array.length === 1) {
    // we must not use a single item array, as it's converted to an expression that the api interprets as being a string rather than an array. Duplicates are handled in the receiving end
    const item = array[0];
    array.push(item);
  }
  return array.reduce((acc, item) => {
    const newItem = `&${arrayName}[]=${item}`;
    return acc + newItem;
  }, "");
}

*/

export function querifyArray(ref: any) {
  const [arrayName, array] = Object.entries(ref)?.[0] || [];
  if (!arrayName || !array) {
    throw new Error(`invalid arg: ${ref}`);
  }
  if (!Array.isArray(array)) {
    throw new Error(`${arrayName} must be an array`);
  }
  if (array.length == 0) return "";
  /* if (array.length === 1) {
    // we must not use a single item array, as it's converted to an expression that the api interprets as being a string rather than an array. Duplicates are handled in the receiving end
    const item = array[0];
    array.push(item);
  } */
  const res = array
    .reduce((acc, item) => {
      const newItem = `${arrayName}[]=${item}&`;
      return acc + newItem;
    }, "")
    .slice(0, -1);

  // console.log("querifyArray , ", Object.keys(ref)[0], ": ", res);
  return res;
}

export const to_query_params = (params: Record<string, any>) => {
  return Object.entries(params)
    .map(
      ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
    )
    .join("&");
};

export function getOriginAndPathFromUrl(url: string): string {
  const index = url.indexOf("?") === -1 ? url.length - 1 : url.indexOf("?");
  return url.substr(0, index);
}

export function setQueryParams(
  url: string,
  keyValue: Array<[string, number | string]>
) {
  const baseUrl = getOriginAndPathFromUrl(url);
  const search =
    url.indexOf("?") === -1 ? "" : url.substr(url.indexOf("?") + 1);
  const searchParams = new URLSearchParams(search);
  for (const item of keyValue) {
    const [key, value] = item;
    searchParams.set(key, value.toString());
  }
  return baseUrl + "?" + searchParams.toString();
}

export function getQParam(url: string, param: string, defaultVal = "") {
  const search =
    url.indexOf("?") === -1 ? "" : url.substr(url.indexOf("?") + 1);
  if (search.length === 0) {
    return defaultVal;
  }

  const searchParams = new URLSearchParams(search);
  if (searchParams.has(param)) {
    return searchParams.get(param);
  } else {
    return defaultVal;
  }
}
